/**
 * CSS embedded inside the standalone annotation SVG export so the document is
 * self-contained for external consumers (e.g. PoleOS) and not dependent on any
 * stylesheet from the host page. The renderer already applies most visual
 * properties inline, so these rules act as defaults that match what the
 * interactive editor uses (see `test.style.css` and `theme.ts`).
 *
 * Quotes (`'` / `"`) are intentionally avoided in the CSS body — the XML exporter
 * HTML-escapes text content and entities inside `<style>` are not parsed as
 * CSS, which would break any quoted selectors/values.
 */
export const STANDALONE_SVG_CSS = `
.c-Draw,
.c-Draw__Svg {
	text-rendering: optimizeLegibility;
}

.c-Draw-Line {
	stroke: #000;
	stroke-width: 1.5;
}

.c-Draw-Line--secondary {
	stroke: #fefefe;
}

.c-Draw-Label {
	fill: rgb(224, 224, 224);
	stroke: #e1ab29;
}

.c-Draw-Marker--base-offset .c-Draw-Label {
	fill: #cccccc;
}

.c-Draw-Label__Text {
	stroke: none;
	fill: rgba(0, 0, 0, 0.87);
	text-anchor: middle;
	user-select: none;
	pointer-events: none;
}
`.trim();
